import React, { FC } from 'react';

import { ControlledMultiSelect, SelectAll } from './MultiSelect';
import StyledSelect from './StyledSelect';

interface Option {
  id: string | number;
  value: string;
  label: unknown;
}

interface StyledSelectContainerProps {
  canSelectAll?: boolean;
  isMulti?: boolean;
  options: Option[];
}

export const StyledSelectContainer: FC<StyledSelectContainerProps> = props => {
  if (props.isMulti && props.options.length > 0) {
    if (props.canSelectAll) {
      return <SelectAll {...props} />;
    }

    return <ControlledMultiSelect {...props} />;
  }

  return (
    // @ts-expect-error this should go away when converting `StyledSelect`
    <StyledSelect {...props} />
  );
};

export default StyledSelectContainer;
